import styled from 'styled-components';

import CheckboxInputInput from './CheckboxInputInput';

export default styled.label`
  background-color: rgba(111, 88, 255, 0.1);
  background-clip: content-box;
  border: 1px rgba(111, 88, 255, 0.3) solid;
  border-radius: 0.6rem;
  display: block;
  flex-shrink: 0;
  height: 2rem;
  width: 2rem;
  margin-bottom: 0;
  padding: 0;

  ${CheckboxInputInput}:hover ~ & {
    background-color: rgba(111, 88, 255, 0.3);
    border-color: rgba(111, 88, 255, 1);
    cursor: pointer;
  }

  ${CheckboxInputInput}:disabled ~ &,
  ${CheckboxInputInput}[readonly] ~ & {
    background-color: rgba(250, 249, 247, 1);
    border-color: rgba(213, 213, 213, 1);
  }
`;
